/**
 * Źródła rekordów banku zleceń — kopia stałych z API.
 *
 * Backend: `apps/api/src/user-offers/zrodla.ts` (demo) i
 * `apps/api/src/via/tms-mapowanie.ts` (TMS). Zgodności pilnuje `zrodlo.test.ts`,
 * czytając te pliki — tak samo jak strażnik stanów w `stanPlanowania.test.ts`.
 *
 * Dane demo są oznaczone W DANYCH (`sourceSystem = 'demo'`, numer `DEMO/…`);
 * ekran ma to tylko pokazać tak, żeby nie dało się przeoczyć.
 */

export const SOURCE_DEMO = 'demo';
export const SOURCE_TMS = 'via-tms';
export const SOURCE_PRE_ORDER = 'prezlecenie';

export const isDemo = (source: unknown): boolean => source === SOURCE_DEMO;

/**
 * Dymek przy danych pokazowych — ten sam na liście (`listCells.tsx`) i na
 * karcie zlecenia (`cells.tsx`). Bez żargonu „rekord z zasiewu demo”,
 * a „systemy klienta” to dla planisty systemy Marathonu, nie zleceniodawcy
 * (poprawa brzmienia 01.10.2026).
 */
export const DEMO_SOURCE_HINT =
  'Zlecenie pokazowe z danymi testowymi. Nie pochodzi z systemów Marathonu.';

/** Etykieta źródła TMS — „TMS”, nie „TMS klienta”: dla planisty to jego TMS. */
const SOURCE_TMS_LABEL = 'TMS';

/**
 * Wybór w filtrze „Źródło” banku — etykiety jak w kolumnie. Wcześniej pole
 * tekstowe, w które trzeba było wpisać kod (`via-tms`, `prezlecenie`), e2e
 * 28.09.2026. Klucz filtra (`sourceSystem`) i wartości — bez zmian.
 */
export const SOURCE_CHOICES = [
  { id: SOURCE_TMS, name: SOURCE_TMS_LABEL },
  { id: SOURCE_PRE_ORDER, name: 'Prezlecenie' },
  { id: SOURCE_DEMO, name: 'DEMO' },
];

/** Etykieta źródła dla planisty; nieznane źródło pokazujemy jak jest, brak — jako brak. */
export function sourceLabel(source: string | undefined): string {
  if (!source) return '—';
  if (source === SOURCE_TMS) return SOURCE_TMS_LABEL;
  if (source === SOURCE_PRE_ORDER) return 'Prezlecenie';
  return source;
}
